
import React from 'react';
import * as IoC from 'typescript-ioc';
import { DateTimeFormatter } from '../../../../../../infrastructure/implementations/date-formatter';
import Text from '../../../../../global/text/text';
import { isSameDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import classNames from 'classnames';
import { RecordingsStatus } from '../../../../../../api/meetings.dao';
import { observer } from 'mobx-react';
import { getFormattedTimezoneOffset } from '../../../../../../infrastructure/utils/date-fns-overrides.utils';
import { DateFnsFormats } from '../../../../../../infrastructure/date-formatter';

export interface IMeetingConnectionsListItemFiltersProps {
    startDateTime: string;
    endDateTime: string;
    eventTimezone: string;
    showDates: boolean;
    meetingRecordEnabled: boolean;
}

const MeetingConnectionsListItemFilters = observer((props: IMeetingConnectionsListItemFiltersProps) => {
    const {
        startDateTime,
        endDateTime,
        eventTimezone,
        showDates,
        meetingRecordEnabled
    } = props;

    const startDate = new Date(startDateTime);
    const endDate = new Date(endDateTime);

    const dateTimeFormatter = IoC.Container.get(DateTimeFormatter);

    const startTime = dateTimeFormatter.dateToFormattedString(startDate, dateTimeFormatter.getLocalTimeFormat());
    const endTime = dateTimeFormatter.dateToFormattedString(endDate, dateTimeFormatter.getLocalTimeFormat());

    const startTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(startDate, dateTimeFormatter.getLocalTimeFormat(), eventTimezone);
    const endTimeInEventTimezone = dateTimeFormatter.dateToFormattedString(endDate, dateTimeFormatter.getLocalTimeFormat(), eventTimezone);

    const isEventTimezoneTimeDifferents = startTimeInEventTimezone !== startTime;
    const timeZoneOffset = getFormattedTimezoneOffset(startDate);
    const localDayString = dateTimeFormatter.dateToFormattedString(startDate, DateFnsFormats.StringifiedFullDayMonthNumericDateYear);
    const eventDayString = dateTimeFormatter.dateToFormattedString(startDate, DateFnsFormats.StringifiedFullDayMonthNumericDateYear, eventTimezone);

    return (
        <td className='hoverable column-with-filters'>
            {showDates &&
                <div className='meeting-list-item__header--date-and-time' data-testid='room-day'>
                    {eventDayString}
                </div>}
            <div className='meeting-list-item__header--date-and-time'>
                {startTimeInEventTimezone} - {endTimeInEventTimezone}
            </div>
            {!isSameDay(startDate, utcToZonedTime(startDate, eventTimezone)) &&
                <div className='meeting-list-item__text meeting-list-item__text--small meeting-list-item__text--date-and-time'
                    data-testid='local-day'>
                    {localDayString}
                </div>
            }
            {isEventTimezoneTimeDifferents &&
                <div className='meeting-list-item__text meeting-list-item__text--small'>
                    {startTime} - {endTime} ({timeZoneOffset})
                </div>
            }
            <div className='meeting-list-item-recordings'>
                <div className={classNames('recordings-icon', { 'recordings-icon-active': meetingRecordEnabled })} />
                <Text
                    withEllipsis
                    className='meeting-list-item__text'
                    message={`Record Meeting: ${meetingRecordEnabled ? RecordingsStatus.Yes : RecordingsStatus.No}`} />
            </div>
        </td>
    );
});

export { MeetingConnectionsListItemFilters };
